import EditorPage from '../pages/EditorPage';
import MainPage from '../pages/MainPage';
import QualificationPage from '../pages/QualificationPage';
import ProPage from '../pages/ProPage'
import SportPage from '../pages/SportPage'
import StreetPage from '../pages/StreetPage'

export const publicRoutes = [
  { path: '/main', component: MainPage, exact: true },
  { path: '/qualification', component: QualificationPage, exact: true },
  { path: '/pro', component: ProPage, exact: true },
  { path: '/sport', component: SportPage, exact: true },
  { path: '/street', component: StreetPage, exact: true },
];

export const privateRoutes = [
  { path: '/editor', component: EditorPage, exact: true },
];
